(() => {
  const mediaQuery = window.matchMedia('(max-width: 749px)');
  let heroRevealTimer;

  const firstHero = () => document.querySelector('main[data-template="index"] .hero[id*="hero_jVaWmY"]');

  const setupHeroReveal = () => {
    const hero = firstHero();

    if (heroRevealTimer) {
      window.clearTimeout(heroRevealTimer);
      heroRevealTimer = undefined;
    }

    if (!hero) return;

    hero.classList.remove('daochant-hero-visual-ready');

    if (!mediaQuery.matches) return;

    const reveal = () => {
      hero.classList.add('daochant-hero-visual-ready');
    };
    const media = hero.querySelector('.hero__media');

    if (!media) {
      window.requestAnimationFrame(reveal);
      return;
    }

    if (media instanceof HTMLVideoElement) {
      media.muted = true;
      media.defaultMuted = true;
      media.autoplay = true;
      media.loop = true;
      media.playsInline = true;
      media.preload = 'auto';
      media.disablePictureInPicture = true;
      media.setAttribute('muted', '');
      media.setAttribute('autoplay', '');
      media.setAttribute('loop', '');
      media.setAttribute('playsinline', '');
      media.setAttribute('webkit-playsinline', '');
      media.setAttribute('controlsList', 'nodownload noplaybackrate noremoteplayback');
      media.removeAttribute('controls');

      const mobileSource = media.querySelector('source[media*="max-width"]');
      if (!media.currentSrc && mobileSource?.getAttribute('src')) {
        media.load();
      }

      const play = () => {
        media.removeAttribute('controls');

        if (!media.paused && !media.ended) return;

        const playPromise = media.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {});
        }
      };

      play();
      media.addEventListener('loadedmetadata', play, { once: true });
      media.addEventListener('loadeddata', play, { once: true });
      media.addEventListener('canplay', play, { once: true });
      window.setTimeout(play, 350);
      window.setTimeout(play, 1200);
      window.addEventListener('pageshow', play, { once: true });
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden) play();
      }, { once: true });
      document.addEventListener('touchstart', play, { once: true, passive: true });

      const poster = media.getAttribute('poster');

      if (media.readyState >= 2) {
        window.requestAnimationFrame(reveal);
      } else if (poster) {
        const posterImage = new Image();
        posterImage.addEventListener('load', reveal, { once: true });
        posterImage.addEventListener('error', reveal, { once: true });
        posterImage.src = poster;
      }

      media.addEventListener('loadeddata', reveal, { once: true });
      media.addEventListener('canplay', reveal, { once: true });
      heroRevealTimer = window.setTimeout(reveal, 900);
      return;
    }

    if (media instanceof HTMLImageElement) {
      if (media.complete && media.naturalWidth > 0) {
        window.requestAnimationFrame(reveal);
      } else {
        media.addEventListener('load', reveal, { once: true });
        media.addEventListener('error', reveal, { once: true });
      }
      return;
    }

    window.requestAnimationFrame(reveal);
  };

  const setup = () => {
    setupHeroReveal();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup, { once: true });
  } else {
    setup();
  }

  mediaQuery.addEventListener('change', setup);
})();
